core.component('coreAulasComponent', {
    templateUrl: 'components/aulas/aulas.html',
    controller: 'coreAulasController',
    controllerAs: '$ctrl',
    bindings:{ config: '<' }
});

core.controller('coreAulasController', ['$scope', 'coreLanguage', 'coreFb', '$state', '$sce', '$filter', 'coreUtils', '$timeout', function($scope, $text, $fb, $state, $sce, $filter, $utils, $timeout){
    var $ctrl = this;
    $scope.$text = $text;

    $ctrl.progresso = {};
    $ctrl.downloading = {};
    $ctrl.respostas = {};

    const _getModulo=()=>{

        $fb.db.get($ctrl.config.moduloPath).then(doc=>{
            $ctrl.modulo = doc;

            if(doc.data.tipoModulo === 'link'){
                window.open(doc.data.linkUrl, doc.data.target);
                return;
            }

            return $fb.db.list($ctrl.config.moduloPath+'/aulas', [{orderBy:['ordem']}]);

        }).then((list)=>{
            $ctrl.aulas = $filter('orderBy')(list, 'data.ordem');

            return $fb.db.list(`sys_progresso`, [{where:['criacao.idUsuario', '==', $ctrl.idUsuario]}, {where:['idProduto', '==', $ctrl.config.idProduto]}, {limit:[1]}]);

        }).then((progressoList=>{

            if(progressoList.length){
                $ctrl.progresso = progressoList[0];
                _calcPercent();

            }else{
                $fb.db.add('sys_progresso', {idProduto: $ctrl.config.idProduto, aulas:[]}).then(doc=>{ 
                    $ctrl.progresso.id = doc.id; 
                    $ctrl.progresso._percent = 0;
                    $ctrl.progresso.data = {};
                });
            }

            if($ctrl.aulas && $ctrl.aulas.length){
                let aulaAtual = false;

                $ctrl.aulas.forEach(aula=>{
                    if(!aulaAtual && !$ctrl.isConcluded(aula.id)){
                        aulaAtual = aula;
                    }
                });

                let aulaToSet = aulaAtual || $ctrl.aulas[0];
                $ctrl.setAula(aulaToSet);
            }

        })).finally(()=>{
            $state.params.showGlobalLoading = false;
        });

    };

    const _calcPercent=()=>{
        if($ctrl.aulas && !$ctrl.loadingProgresso){
            $ctrl.loadingProgresso = true;
            
            $fb.functions.invoke('aulas_listProgress').then(list=>{
                let progProduto = list.find(item=>{ return item.codProduto === $ctrl.config.idProduto });

                $ctrl.progresso._percent = progProduto?.progresso?? 0;
                $ctrl.loadingProgresso = false;
            });
        }
    };

    const _setConcluded=(aulaId)=>{
        if(!$ctrl.progresso.id || aulaId !== $ctrl.selectedAula.id){
            return;
        }

        let reload = $ctrl.selectedAula.data.tipo==='quiz';

        $fb.db.get(`sys_progresso/${$ctrl.progresso.id}`).then(doc=>{

            let aulas = doc.data.aulas || [];

            let hasAula = $filter('filter')(aulas, {id: aulaId }, true);

            if(hasAula.length){
                return;
            }

            let obj = {id: aulaId, data: new Date()};

            if($ctrl.selectedAula.data.tipo === 'quiz'){
                obj.respostas = $ctrl.respostas;
            }

            aulas.push(obj);
            $ctrl.progresso.data.aulas = aulas;
            
            return $fb.db.update(doc.path, {aulas:aulas});

        }).then((okay)=>{
            _calcPercent();

            //if(reload){ $state.reload(); }
        });
    };

    const _checkProgresso=(aula)=>{

        if(aula.data.tipo === 'quiz'){
            return;
        }

        if(!$ctrl.isConcluded(aula.id)){
            if($ctrl.progressCounter){ $timeout.cancel($ctrl.progressCounter); }

            $ctrl.progressCounter = $timeout(()=>{
                _setConcluded(aula.id);
            }, aula.data.duracao * 1000 || 30000);
        }

    };

    $ctrl.setAula=(aula)=>{
        $ctrl.selectedAula = aula;
        $ctrl.showAulas = false;

        if(aula.data.tipo === 'quiz' && $ctrl.isConcluded(aula.id)){
            $ctrl.respostas = $filter('filter')($ctrl.progresso.data.aulas, {id:aula.id}, true)[0].respostas;
        }

        _checkProgresso(aula);
    };

    $ctrl.previousClass=()=>{
        ///aula anterior
        if($ctrl.selectedAula.data.ordem > 1){
            let prevAula = $filter('filter')($ctrl.aulas, {data:{ordem: $ctrl.selectedAula.data.ordem - 1}}, true)[0];
            $ctrl.setAula(prevAula);
        }else if($ctrl.config.prevModulo){
            $state.go('cliente.produtoModulo', {idProduto:$ctrl.config.idProduto, idModulo:$ctrl.config.prevModulo});
        }
    };

    $ctrl.nextClass=()=>{
        ///próxima aula
        if($ctrl.selectedAula.data.ordem < $ctrl.aulas.length){
            let nextAula = $filter('filter')($ctrl.aulas, {data:{ordem: $ctrl.selectedAula.data.ordem + 1}}, true)[0];
            
            if(nextAula){
                $ctrl.setAula(nextAula);
            }else{
                $state.go('cliente.produto', {idProduto:$ctrl.config.idProduto});
            }

        }else if($ctrl.config.nextModulo){
            $state.go('cliente.produtoModulo', {idProduto:$ctrl.config.idProduto, idModulo:$ctrl.config.nextModulo});
        }
    };

    $ctrl.isConcluded=(aulaId)=>{
        if(!$ctrl.progresso.data || !$ctrl.progresso.data.aulas){
            return;
        }

        let hasAula = $filter('filter')($ctrl.progresso.data.aulas, {id: aulaId}, true);
        return hasAula.length > 0;
    };

    $ctrl.downloadFile=(fileUrl, fileName)=>{
        $ctrl.downloading[fileName] = true;

        $fb.storage.downloadBlob(fileUrl, fileName).finally(() => {
            $ctrl.downloading[fileName] = false;
        });
    };

    $ctrl.getVideoFrame=(valor)=>{
        return `<iframe width='560' height='315' src='${valor}' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share' referrerpolicy='strict-origin-when-cross-origin' allowfullscreen></iframe>`;
    };

    $ctrl.trust=(valor)=>{
        return $sce.trustAsHtml(valor);
    };

    $ctrl.setQuizOption=(questao, idx)=>{
        if(!questao || $ctrl.isConcluded($ctrl.selectedAula.id)){ return; }
        $ctrl.respostas[questao.pergunta.replaceAll(' ', '_')] = idx;
    };
    
    $ctrl.isSelected=(questao, idx)=>{
        if(!questao){ return; }
        return $ctrl.respostas[questao.pergunta.replaceAll(' ', '_')] === idx;
    };

    $ctrl.isRightAnswer=(questao, idx)=>{
        if(!questao){ return; }
        return $ctrl.isConcluded($ctrl.selectedAula.id) && idx === questao.resposta.idx;
    };

    $ctrl.getBtnClass=(questao, idx)=>{

        if($ctrl.isSelected(questao, idx)){

            if($ctrl.isConcluded($ctrl.selectedAula.id)){

                return $ctrl.isRightAnswer(questao, idx) ? 'bg-light-success' : 'bg-light-danger';

            }else{
                return 'selected';
            }

        }else if($ctrl.isRightAnswer(questao, idx)){
            return 'border-light-success';
        }

        return '';

    };

    $ctrl.getProgressoQuiz=()=>{
        let respondidas = 0;
        let totais = 0;

        if($ctrl.respostas){ respondidas = Object.keys($ctrl.respostas).length; }
        if($ctrl.selectedAula){ totais = $ctrl.selectedAula.data.conteudos.length; }

        return respondidas+'/'+totais;
    };

    $ctrl.cleanRespostas=()=>{
        $ctrl.respostas = {};
    };

    $ctrl.disableEnvio=()=>{

        if($ctrl.isConcluded($ctrl.selectedAula.id)){
            return true;
        };

        let respondidas = 0;
        let totais = 0;

        if($ctrl.respostas){ respondidas = Object.keys($ctrl.respostas).length; }
        if($ctrl.selectedAula){ totais = $ctrl.selectedAula.data.conteudos.length; }

        if(respondidas < totais){
            return true;
        }

        return false;
    }

    $ctrl.sendRespostas=()=>{
        if($ctrl.disableEnvio()){
            return;
        }

        _setConcluded($ctrl.selectedAula.id);
    };

    $ctrl.toggleAulas=()=>{
        $ctrl.showAulas = !$ctrl.showAulas;
    };

    $ctrl.$onInit=()=>{
        $ctrl.idUsuario = $ctrl.config.idUsuario;

        _getModulo();
    }

}]);